import React, { useEffect, useState } from 'react';

const OptimizedImage = ({
  src,
  alt,
  className = '',
  loading = 'lazy',
  width,
  height,
  ...props
}) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    setImageSrc(src);
    setRetryCount(0);
  }, [src]);

  const handleError = () => {
    if (retryCount < 1) {
      const cacheBust = `${src}${src.includes('?') ? '&' : '?'}retry=${Date.now()}`;
      setImageSrc(cacheBust);
      setRetryCount((prev) => prev + 1);
    }
  };

  return (
    <img
      src={imageSrc}
      alt={alt}
      className={className}
      loading={loading}
      width={width}
      height={height}
      onError={handleError}
      decoding="async"
      {...props}
    />
  );
};

export default OptimizedImage;
